export default "__VITE_ASSET__aa931f13__"